import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { PlantGroupElement } from '../models/O3AdministrationModels/plant-model';
import { Plantbygroup } from '../models/plantbygroup';
import { ProductLine } from '../models/ProductLine';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  O3CoreApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetGroup', data);
  }
  getTreeModal(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.O3CoreApiUrl + 'Common/GetTreeModal', data);
  }
  // getGroups(): Observable<any[]> {
  //   return this.http.get<any[]>(this.kpiUrl + 'groups');
  // }

  // getPlants(groupId: any): Observable<Plantbygroup[]> {
  //   return this.http.post<Plantbygroup[]>(this.kpiUrl + 'plantsbygroup', groupId);
  // }

  getmasterline(data: any): Observable<ProductLine[]> {
    return this.http.post<ProductLine[]>(this.O3CoreApiUrl + 'Machine/GetMasterLines', data);
  }
  async getMachineByLine(data: any): Promise<any> {
    return await this.http.post<any[]>(this.O3CoreApiUrl + 'Machine/GetUnitsByLine', data).toPromise();
  }
  getProductsByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCR/Productsbyunit', data);
  }

  getPeopleMasterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PeopleMaster/GetEmployeeMasterInfoData', data);
  }
  getPeopleMasterEmpData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PeopleMaster/GetEmployeeMasterInfo', data);
  }
  getLineList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetLineList', data);
  }

  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetUnitList', data);
  }

  productionOutputByBarcode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'BarcodePrint/ProductionOutputByBarcode', data);
  }

  GetFullNameByUserId(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetFullNameByUserId',data);
  }

  GetTeamList(): Observable<any[]> {
    return this.http.get<any[]>(this.O3CoreApiUrl + 'User/getUsersByPlant');
  }

  GetUserByDepartment(data:any): Observable<any[]>
  {
   return this.http.post<any[]>(this.O3CoreApiUrl + 'CommonIntegrated/GetUserByDepartment' , data);
  }
  resetUserPassword(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Auth/resetUserPassword', payload);
  }
}
